export default () => {
  const patterns = {
    local: /localhost/,
    dev: /phoenix-api\.dev\.elevatelimited/,
    staging: /phoenix-api\.staging\.elevatelimited/,
    onboard: /phoenix-onboard-api\.elevatelimited/,
    prod: /phoenix-api\.elevatelimited\.com/,
  };

  let result = 'unknown';
  Object.keys(patterns).forEach(name => {
    if (patterns[name].test(API_URL)) {
      result = name.toUpperCase();
    }
  });

  return result;
};
